import $axios from '../config.js'
import { url } from '../api_urls/homePage.js'

// 获取home page 列表
export function findList (params) {
  return $axios.post(url.findList, params)
}

// 申请权限
export function applyForWebAuthority (params) {
  return $axios.post(url.applyForWebAuthority, params)
}

// 获取web banner list
export function getWebBanner (params) {
  return $axios.post(url.getWebBanner, params)
}

// 检查是否收藏
export function checkCollection (params) {
  return $axios.post(url.checkCollection, params)
}

// 添加收藏
export function addCollection (params) {
  return $axios.post(url.addCollection, params)
}

// 取消收藏
export function removeCollection (params) {
  return $axios.post(url.removeCollection, params)
}



// WEBPACK FOOTER //
// ./src/axios/api/homePage.js